





import { Component, Prop, Vue } from 'vue-property-decorator'
import { ILabelValue } from '@/interfaces/generic'
const ApexCharts = () => import(`vue-apexcharts`)

@Component({
  components: {
    ApexCharts
  }
})
export default class StatPieChart extends Vue {
  @Prop()
  title: string

  @Prop()
  items: ILabelValue[]

  options = {
    chart: {
      background: '#363636',
      toolbar: {
        show: false
      }
    },
    labels: this.labels,
    dataLabels: {
      dropShadow: {
        enabled: false // prevents stdDeviation warning
      }
    },
    colors: ['#13ad13', '#ff40b4', '#32B8B4', '#3263B8', '#8732B8', '#37B832', '#B83235', '#B8B432', '#32B887', '#5B32B8', '#B83237'],
    theme: {
      mode: 'dark',
      monochrome: {
        enabled: false
      }
    },
    tooltip: {
      fillSeriesColor: false
    },
    stroke: {
      show: false,
      width: 1,
      colors: ['#e9e9e9']
    }
  }

  get series(): number[] {
    return this.items.map(x => x.value)
  }

  get labels(): string[] {
    return this.items.map(x => x.label)
  }
}
